import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider as MuiDivider,
  Grid,
  IconButton,
  TextField,
} from "@material-ui/core";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { Box } from "@material-ui/system";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { GetConfig } from "../../../../../utils/ConfigHeader";
import { useDebounceSearch } from "../../../../../hooks/useDebounceSearch";
import { getBrach } from "../../../../../utils/jwt";

function escapeRegExp(value) {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}

function QuickSearchToolbar(props) {
  return (
    <Box sx={{ bgcolor: "yellow" }}>
      <TextField
        variant="standard"
        value={props.value}
        onChange={props.onChange}
        placeholder="Search…"
        InputProps={{
          startAdornment: <SearchIcon fontSize="small" />,
          endAdornment: (
            <IconButton
              title="Clear"
              aria-label="Clear"
              size="small"
              style={{ visibility: props.value ? "visible" : "hidden" }}
              onClick={props.clearSearch}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ),
        }}
        sx={{
          width: {
            xs: 1,
            sm: "auto",
          },
          pr: 4,
          m: (theme) => theme.spacing(0),
          "& .MuiSvgIcon-root": {
            mr: 5,
          },
          "& .MuiInput-underline:before": {
            borderBottom: 1,
            borderColor: "divider",
          },
          float: "right",
        }}
      />
    </Box>
  );
}

QuickSearchToolbar.propTypes = {
  clearSearch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default function CustomerPopup(props) {
  //state Customer ID
  const [openCust, setOpenCust] = React.useState(props.openCust);
  const [searchText, setSearchText] = React.useState("");
  const [DataCust, setDataCust] = useState([]);
  const [FilterCustomer, setFilterCustomer] = React.useState([]);
  const [widthrow, setwidthrow] = useState(440);
  const [widthrow2, setwidthrow2] = useState(200);
  const [Rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const searchDebounce = useDebounceSearch(searchText);

  const [SelectedCust, setSelectedCust] = React.useState(() =>
    DataCust.filter((el) => {
      return FilterCustomer.some((f) => {
        return (
          f.CustomerName === el.CustomerName &&
          f.CustID === el.CustID &&
          f.Address1 === el.Address1 &&
          f.Address2 === el.Address2
        );
      });
    })
  );

  const [allData, setAllData] = useState([]);
  const [currentpage, setcurrentpage] = React.useState(0); // Zero-based for client-side pagination
  const [pageSize, setPageSize] = useState(5);
  const columnsCust = [
    {
      field: "customerID",
      headerName: "Customer ID",
      width: 150,
      sortable: false,
    },
    {
      field: "customerName",
      headerName: "Customer Name",
      width: widthrow,
    },
    {
      field: "addressLine1",
      headerName: "Address Line 1",
      width: widthrow2,
    },
    {
      field: "addressLine2",
      headerName: "Address Line 2",
      width: 200,
    },
  ];

  useEffect(() => {
    setOpenCust(props.openCust);
  }, [props.openCust]);

  // Load all data when dialog opens or search changes
  useEffect(() => {
    if (openCust) {
      // Only fetch data once when dialog opens or search changes
      getAllData();
    }
  }, [openCust, searchDebounce]);

  // Get all customer data at once
  const getAllData = async () => {
    try {
      setLoading(true);
      const res = await axios
        .get(
          `${process.env.REACT_APP_DOMAIN_API}` +
            `/CustomerReps/PopUp/Customer?rowsCount=25&customerName=${searchDebounce}&branch=${getBrach()}`,
          GetConfig()
        )
        .then(function (response) {
          setLoading(false);
          if (response.status == 200) {
            const resdata = response.data[0];
            if (resdata.record !== null) {
              setAllData(resdata.record);
              setDataCust(resdata.record);
              // Apply filtering client-side if needed
              const filteredData = resdata.record;
              setRows(filteredData);
              // Calculate column widths
              let nameLength = 1;
              let addressLength = 1;
              filteredData.forEach((ae) => {
                if (nameLength <= ae.customerName.length) {
                  nameLength = ae.customerName.length;
                }
                if (addressLength <= ae.addressLine1.length) {
                  addressLength = ae.addressLine1.length;
                }
              });
              setwidthrow(nameLength * 7.6 + 30);
              setwidthrow2(addressLength * 7.6 + 30);
            } else {
              setAllData([]);
              setDataCust([]);
              setRows([]);
            }
          }
        })
        .catch(function (error) {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error.message);
    }
  };

  const getAdmin = (id) => {
    try {
      axios
        .get(
          `${process.env.REACT_APP_DOMAIN_API}/CustomerReps/${id}`,
          GetConfig()
        )
        .then(function (response) {
          if (response.status === 200) {
            props.setTempCustomer({
              ...response.data,
              AddressLine1: SelectedCust.addressLine1,
            });
            props.setopenCust(false);
            setSelectedCust("");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    } catch (error) {
      console.log(error.message);
    }
  };

  const handlePageChange = (newPage) => {
    setcurrentpage(newPage);
  };
  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
  };

  return (
    <React.Fragment>
      <Dialog
        open={openCust}
        fullWidth={true}
        maxWidth={"md"}
        onClose={() => {
          props.setopenCust(false);
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Select Customer</DialogTitle>
        <DialogContent>
          <Grid container md={12}>
            <Grid item md={6} xs={12}>
              <DialogContentText>Customer List</DialogContentText>
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                variant="standard"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search…"
                InputProps={{
                  startAdornment: <SearchIcon fontSize="small" />,
                  endAdornment: (
                    <IconButton
                      title="Clear"
                      aria-label="Clear"
                      size="small"
                      style={{ visibility: searchText ? "visible" : "hidden" }}
                      onClick={() => setSearchText("")}
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  ),
                }}
                sx={{
                  width: {
                    xs: 1,
                    sm: "auto",
                  },
                  pr: 4,
                  m: (theme) => theme.spacing(0),
                  "& .MuiSvgIcon-root": {
                    mr: 5,
                  },
                  "& .MuiInput-underline:before": {
                    borderBottom: 1,
                    borderColor: "divider",
                  },
                  float: "right",
                }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} md={12} mt={2}>
            <div style={{ width: "100%" }}>
              <DataGrid
                rows={Rows}
                getRowId={(row) => row.customerID}
                columns={columnsCust}
                autoHeight
                pageSize={pageSize}
                rowsPerPageOptions={[5, 10, 25]}
                onPageSizeChange={handlePageSizeChange}
                selectionModel={
                  SelectedCust !== "" ? SelectedCust?.customerID : ""
                }
                density="compact"
                onSelectionModelChange={(e) => {
                  if (e.length > 0) {
                    setSelectedCust(
                      Rows.filter((i) => e.includes(i.customerID))[0]
                    );
                  }
                }}
                paginationMode="client"
                page={currentpage}
                pagination
                onPageChange={handlePageChange}
                loading={loading}
              />
            </div>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              props.setopenCust(false);
              setSelectedCust("");
            }}
            color="warning"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (SelectedCust !== undefined) {
                getAdmin(SelectedCust.customerID);
              } else {
                props.setTempCustomer("");
                props.setopenCust(false);
                setSelectedCust("");
              }
            }}
            disabled={!!SelectedCust ? false : true}
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
